// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1477":"44f97ec3","4048":"6d57f6f5","5397":"6d57f6f5","7152":"6d57f6f5","8170":"fce90fea"}[chunkId] + ".chunk.css";
};